(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-routine-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('collection-routine-card')) {
    customElements.define('collection-routine-card', class extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        this.button?.addEventListener('click', this.addRoutine.bind(this));
      }

      async addRoutine() {
        if (this.button.disabled || this.button.getAttribute('aria-busy') === 'true') {
          return;
        }

        this.button.setAttribute('aria-busy', 'true');

        const sections = new Set();
        document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
          bubbles: true,
          detail: {sections},
        }));

        try {
          const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify({
              items: this.dataset.variantIds.split(',').filter(Boolean).map((id) => ({id, quantity: 1})),
              sections: [...sections].join(','),
            }),
          });
          const responseJson = await response.json();

          if (!response.ok) {
            throw new Error(responseJson.description || responseJson.message);
          }

          const cart = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
          cart.sections = responseJson.sections;
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
            bubbles: true,
            detail: {
              baseEvent: 'variant:add',
              cart,
            },
          }));
          document.dispatchEvent(new CustomEvent('toast:show', {
            detail: {message: this.dataset.successMessage},
          }));
        } catch (error) {
          document.dispatchEvent(new CustomEvent('toast:show', {
            detail: {message: error.message || this.dataset.errorMessage, tone: 'error'},
          }));
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true}));
        } finally {
          this.button.removeAttribute('aria-busy');
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
